import { KD_COUNTRY, KD_STATE } from '../../constants';

export default {
  [KD_STATE]: [
    {
      value: 'NewEngland',
      label: 'New England',
      data: [
        {
          id: 'CT',
          value: '019.021.US.CT',
          label: 'Connecticut',
          entityType: KD_STATE,
        },
        {
          id: 'ME',
          value: '019.021.US.ME',
          label: 'Maine',
          entityType: KD_STATE,
        },
        {
          id: 'MA',
          value: '019.021.US.MA',
          label: 'Massachusetts',
          entityType: KD_STATE,
        },
        {
          id: 'NH',
          value: '019.021.US.NH',
          label: 'New Hampshire',
          entityType: KD_STATE,
        },
        {
          id: 'RI',
          value: '019.021.US.RI',
          label: 'Rhode Island',
          entityType: KD_STATE,
        },
        {
          id: 'VT',
          value: '019.021.US.VT',
          label: 'Vermont',
          entityType: KD_STATE,
        },
      ],
    },
    {
      value: 'MidAtlantic',
      label: 'Mid-Atlantic',
      data: [
        {
          id: 'DE',
          value: '019.021.US.DE',
          label: 'Delaware',
          entityType: KD_STATE,
        },
        {
          id: 'MD',
          value: '019.021.US.MD',
          label: 'Maryland',
          entityType: KD_STATE,
        },
        {
          id: 'NJ',
          value: '019.021.US.NJ',
          label: 'New Jersey',
          entityType: KD_STATE,
        },
        {
          id: 'NY',
          value: '019.021.US.NY',
          label: 'New York',
          entityType: KD_STATE,
        },
        {
          id: 'PA',
          value: '019.021.US.PA',
          label: 'Pennsylvania',
          entityType: KD_STATE,
        },
        {
          id: 'DC',
          value: '019.021.US.DC',
          label: 'District of Columbia',
          entityType: KD_STATE,
        },
      ],
    },
    {
      value: 'South',
      label: 'South',
      data: [
        {
          id: 'AL',
          value: '019.021.US.AL',
          label: 'Alabama',
          entityType: KD_STATE,
        },
        {
          id: 'AR',
          value: '019.021.US.AR',
          label: 'Arkansas',
          entityType: KD_STATE,
        },
        {
          id: 'FL',
          value: '019.021.US.FL',
          label: 'Florida',
          entityType: KD_STATE,
        },
        {
          id: 'GA',
          value: '019.021.US.GA',
          label: 'Georgia',
          entityType: KD_STATE,
        },
        {
          id: 'KY',
          value: '019.021.US.KY',
          label: 'Kentucky',
          entityType: KD_STATE,
        },
        {
          id: 'LA',
          value: '019.021.US.LA',
          label: 'Louisiana',
          entityType: KD_STATE,
        },
        {
          id: 'MS',
          value: '019.021.US.MS',
          label: 'Mississippi',
          entityType: KD_STATE,
        },
        {
          id: 'NC',
          value: '019.021.US.NC',
          label: 'North Carolina',
          entityType: KD_STATE,
        },
        {
          id: 'SC',
          value: '019.021.US.SC',
          label: 'South Carolina',
          entityType: KD_STATE,
        },
        {
          id: 'TN',
          value: '019.021.US.TN',
          label: 'Tennessee',
          entityType: KD_STATE,
        },
        {
          id: 'VA',
          value: '019.021.US.VA',
          label: 'Virginia',
          entityType: KD_STATE,
        },
        {
          id: 'WV',
          value: '019.021.US.WV',
          label: 'West Virginia',
          entityType: KD_STATE,
        },
      ],
    },
    {
      value: 'MidWest',
      label: 'Midwest',
      data: [
        {
          id: 'IL',
          value: '019.021.US.IL',
          label: 'Illinois',
          entityType: KD_STATE,
        },
        {
          id: 'IN',
          value: '019.021.US.IN',
          label: 'Indiana',
          entityType: KD_STATE,
        },
        {
          id: 'IA',
          value: '019.021.US.IA',
          label: 'Iowa',
          entityType: KD_STATE,
        },
        {
          id: 'KS',
          value: '019.021.US.KS',
          label: 'Kansas',
          entityType: KD_STATE,
        },
        {
          id: 'MI',
          value: '019.021.US.MI',
          label: 'Michigan',
          entityType: KD_STATE,
        },
        {
          id: 'MN',
          value: '019.021.US.MN',
          label: 'Minnesota',
          entityType: KD_STATE,
        },
        {
          id: 'MO',
          value: '019.021.US.MO',
          label: 'Missouri',
          entityType: KD_STATE,
        },
        {
          id: 'NE',
          value: '019.021.US.NE',
          label: 'Nebraska',
          entityType: KD_STATE,
        },
        {
          id: 'ND',
          value: '019.021.US.ND',
          label: 'North Dakota',
          entityType: KD_STATE,
        },
        {
          id: 'OH',
          value: '019.021.US.OH',
          label: 'Ohio',
          entityType: KD_STATE,
        },
        {
          id: 'SD',
          value: '019.021.US.SD',
          label: 'South Dakota',
          entityType: KD_STATE,
        },
        {
          id: 'WI',
          value: '019.021.US.WI',
          label: 'Wisconsin',
          entityType: KD_STATE,
        },
      ],
    },
    {
      value: 'SouthWest',
      label: 'Southwest',
      data: [
        {
          id: 'AZ',
          value: '019.021.US.AZ',
          label: 'Arizona',
          entityType: KD_STATE,
        },
        {
          id: 'NM',
          value: '019.021.US.NM',
          label: 'New Mexico',
          entityType: KD_STATE,
        },
        {
          id: 'OK',
          value: '019.021.US.OK',
          label: 'Oklahoma',
          entityType: KD_STATE,
        },
        {
          id: 'TX',
          value: '019.021.US.TX',
          label: 'Texas',
          entityType: KD_STATE,
        },
      ],
    },
    {
      value: 'West',
      label: 'West',
      data: [
        {
          id: 'AK',
          value: '019.021.US.AK',
          label: 'Alaska',
          entityType: KD_STATE,
        },
        {
          id: 'CO',
          value: '019.021.US.CO',
          label: 'Colorado',
          entityType: KD_STATE,
        },
        {
          id: 'CA',
          value: '019.021.US.CA',
          label: 'California',
          entityType: KD_STATE,
        },
        {
          id: 'HI',
          value: '019.021.US.HI',
          label: 'Hawaii',
          entityType: KD_STATE,
        },
        {
          id: 'ID',
          value: '019.021.US.ID',
          label: 'Idaho',
          entityType: KD_STATE,
        },
        {
          id: 'MT',
          value: '019.021.US.MT',
          label: 'Montana',
          entityType: KD_STATE,
        },
        {
          id: 'NV',
          value: '019.021.US.NV',
          label: 'Nevada',
          entityType: KD_STATE,
        },
        {
          id: 'OR',
          value: '019.021.US.OR',
          label: 'Oregon',
          entityType: KD_STATE,
        },
        {
          id: 'UT',
          value: '019.021.US.UT',
          label: 'Utah',
          entityType: KD_STATE,
        },
        {
          id: 'WA',
          value: '019.021.US.WA',
          label: 'Washington',
          entityType: KD_STATE,
        },
        {
          id: 'WY',
          value: '019.021.US.WY',
          label: 'Wyoming',
          entityType: KD_STATE,
        },
      ],
    },
  ],
  [KD_COUNTRY]: [
    {
      value: 'AmericasNorth',
      label: 'North America',
      data: [
        { value: '019.021.BM', label: 'Bermuda', entityType: KD_COUNTRY },
        { value: '019.021.CA', label: 'Canada', entityType: KD_COUNTRY },
        { value: '019.021.GL', label: 'Greenland', entityType: KD_COUNTRY },
        {
          value: '019.021.PM',
          label: 'Saint Pierre and Miquelon',
          entityType: KD_COUNTRY,
        },
        { value: '019.021.US', label: 'United States', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'AmericasSouth',
      label: 'South America',
      data: [
        { value: '019.005.AR', label: 'Argentina', entityType: KD_COUNTRY },
        { value: '019.005.BO', label: 'Bolivia', entityType: KD_COUNTRY },
        { value: '019.005.BR', label: 'Brazil', entityType: KD_COUNTRY },
        { value: '019.005.CL', label: 'Chile', entityType: KD_COUNTRY },
        { value: '019.005.CO', label: 'Colombia', entityType: KD_COUNTRY },
        { value: '019.005.EC', label: 'Ecuador', entityType: KD_COUNTRY },
        {
          value: '019.005.FK',
          label: 'Falkland Islands',
          entityType: KD_COUNTRY,
        },
        { value: '019.005.GF', label: 'French Guiana', entityType: KD_COUNTRY },
        { value: '019.005.GY', label: 'Guyana', entityType: KD_COUNTRY },
        { value: '019.005.PY', label: 'Paraguay', entityType: KD_COUNTRY },
        { value: '019.005.PE', label: 'Peru', entityType: KD_COUNTRY },
        { value: '019.005.SR', label: 'Suriname', entityType: KD_COUNTRY },
        { value: '019.005.UY', label: 'Uruguay', entityType: KD_COUNTRY },
        { value: '019.005.VE', label: 'Venezuela', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'AmericasCentral',
      label: 'Central America',
      data: [
        { value: '019.013.BZ', label: 'Belize', entityType: KD_COUNTRY },
        { value: '019.013.CR', label: 'Costa Rica', entityType: KD_COUNTRY },
        { value: '019.013.SV', label: 'El Salvador', entityType: KD_COUNTRY },
        { value: '019.013.GT', label: 'Guatemala', entityType: KD_COUNTRY },
        { value: '019.013.HN', label: 'Honduras', entityType: KD_COUNTRY },
        { value: '019.013.MX', label: 'Mexico', entityType: KD_COUNTRY },
        { value: '019.013.NI', label: 'Nicaragua', entityType: KD_COUNTRY },
        { value: '019.013.PA', label: 'Panama', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'AmericasCarribean',
      label: 'Caribbean America',
      data: [
        { value: '019.029.AI', label: 'Anguilla', entityType: KD_COUNTRY },
        {
          value: '019.029.AG',
          label: 'Antigua and Barbuda',
          entityType: KD_COUNTRY,
        },
        { value: '019.029.AW', label: 'Aruba', entityType: KD_COUNTRY },
        { value: '019.029.BS', label: 'Bahamas', entityType: KD_COUNTRY },
        { value: '019.029.BB', label: 'Barbados', entityType: KD_COUNTRY },
        {
          value: '019.029.BQ',
          label: 'Bonaire, Saint Eustatius and Saba',
          entityType: KD_COUNTRY,
        },
        {
          value: '019.029.KY',
          label: 'Cayman Islands',
          entityType: KD_COUNTRY,
        },
        { value: '019.029.CU', label: 'Cuba', entityType: KD_COUNTRY },
        { value: '019.029.CW', label: 'Curaçao', entityType: KD_COUNTRY },
        { value: '019.029.DM', label: 'Dominica', entityType: KD_COUNTRY },
        {
          value: '019.029.DO',
          label: 'Dominican Republic',
          entityType: KD_COUNTRY,
        },
        { value: '019.029.GD', label: 'Grenada', entityType: KD_COUNTRY },
        { value: '019.029.GP', label: 'Guadeloupe', entityType: KD_COUNTRY },
        { value: '019.029.HT', label: 'Haiti', entityType: KD_COUNTRY },
        { value: '019.029.JM', label: 'Jamaica', entityType: KD_COUNTRY },
        { value: '019.029.MQ', label: 'Martinique', entityType: KD_COUNTRY },
        { value: '019.029.MS', label: 'Montserrat', entityType: KD_COUNTRY },
        { value: '019.029.PR', label: 'Puerto Rico', entityType: KD_COUNTRY },
        {
          value: '019.029.BL',
          label: 'Saint Barthélemy',
          entityType: KD_COUNTRY,
        },
        {
          value: '019.029.KN',
          label: 'Saint Kitts and Nevis',
          entityType: KD_COUNTRY,
        },
        { value: '019.029.LC', label: 'Saint Lucia', entityType: KD_COUNTRY },
        {
          value: '019.029.MF',
          label: 'Saint Martin (French Part)',
          entityType: KD_COUNTRY,
        },
        {
          value: '019.029.VC',
          label: 'Saint Vincent and the Grenadines',
          entityType: KD_COUNTRY,
        },
        {
          value: '019.029.SX',
          label: 'Sint Maarten (Dutch Part)',
          entityType: KD_COUNTRY,
        },
        {
          value: '019.029.TT',
          label: 'Trinidad and Tobago',
          entityType: KD_COUNTRY,
        },
        {
          value: '019.029.TC',
          label: 'Turks and Caicos Islands',
          entityType: KD_COUNTRY,
        },
        {
          value: '019.029.VG',
          label: 'Virgin Islands (British)',
          entityType: KD_COUNTRY,
        },
        {
          value: '019.029.VI',
          label: 'Virgin Islands (U.S.)',
          entityType: KD_COUNTRY,
        },
      ],
    },
    {
      value: 'EuropeWestern',
      label: 'Western Europe',
      data: [
        { value: '150.155.AT', label: 'Austria', entityType: KD_COUNTRY },
        { value: '150.155.BE', label: 'Belgium', entityType: KD_COUNTRY },
        { value: '150.155.FR', label: 'France', entityType: KD_COUNTRY },
        { value: '150.155.DE', label: 'Germany', entityType: KD_COUNTRY },
        { value: '150.155.LI', label: 'Liechtenstein', entityType: KD_COUNTRY },
        { value: '150.155.LU', label: 'Luxembourg', entityType: KD_COUNTRY },
        { value: '150.155.MC', label: 'Monaco', entityType: KD_COUNTRY },
        { value: '150.155.NL', label: 'Netherlands', entityType: KD_COUNTRY },
        { value: '150.155.CH', label: 'Switzerland', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'EuropeNorthern',
      label: 'Northern Europe',
      data: [
        { value: '150.154.DK', label: 'Denmark', entityType: KD_COUNTRY },
        { value: '150.154.EE', label: 'Estonia', entityType: KD_COUNTRY },
        { value: '150.154.FO', label: 'Faroe Islands', entityType: KD_COUNTRY },
        { value: '150.154.FI', label: 'Finland', entityType: KD_COUNTRY },
        { value: '150.154.GG', label: 'Guernsey', entityType: KD_COUNTRY },
        { value: '150.154.IS', label: 'Iceland', entityType: KD_COUNTRY },
        { value: '150.154.IE', label: 'Ireland', entityType: KD_COUNTRY },
        { value: '150.154.IM', label: 'Isle of Man', entityType: KD_COUNTRY },
        { value: '150.154.JE', label: 'Jersey', entityType: KD_COUNTRY },
        { value: '150.154.LV', label: 'Latvia', entityType: KD_COUNTRY },
        { value: '150.154.LT', label: 'Lithuania', entityType: KD_COUNTRY },
        { value: '150.154.NO', label: 'Norway', entityType: KD_COUNTRY },
        {
          value: '150.154.SJ',
          label: 'Svalbard and Jan Mayen',
          entityType: KD_COUNTRY,
        },
        { value: '150.154.SE', label: 'Sweden', entityType: KD_COUNTRY },
        {
          value: '150.154.GB',
          label: 'United Kingdom',
          entityType: KD_COUNTRY,
        },
        { value: '150.154.AX', label: 'Åland Islands', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'EuropeSouthern',
      label: 'Southern Europe',
      data: [
        { value: '150.039.AL', label: 'Albania', entityType: KD_COUNTRY },
        { value: '150.039.AD', label: 'Andorra', entityType: KD_COUNTRY },
        {
          value: '150.039.BA',
          label: 'Bosnia and Herzegovina',
          entityType: KD_COUNTRY,
        },
        { value: '150.039.HR', label: 'Croatia', entityType: KD_COUNTRY },
        { value: '150.039.GI', label: 'Gibraltar', entityType: KD_COUNTRY },
        { value: '150.039.GR', label: 'Greece', entityType: KD_COUNTRY },
        { value: '150.039.IT', label: 'Italy', entityType: KD_COUNTRY },
        { value: '150.039.MK', label: 'Macedonia', entityType: KD_COUNTRY },
        { value: '150.039.MT', label: 'Malta', entityType: KD_COUNTRY },
        { value: '150.039.ME', label: 'Montenegro', entityType: KD_COUNTRY },
        { value: '150.039.PT', label: 'Portugal', entityType: KD_COUNTRY },
        { value: '150.039.SM', label: 'San Marino', entityType: KD_COUNTRY },
        { value: '150.039.RS', label: 'Serbia', entityType: KD_COUNTRY },
        { value: '150.039.SI', label: 'Slovenia', entityType: KD_COUNTRY },
        { value: '150.039.ES', label: 'Spain', entityType: KD_COUNTRY },
        { value: '150.039.VA', label: 'Vatican City', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'EuropeEastern',
      label: 'Eastern Europe',
      data: [
        { value: '150.151.BY', label: 'Belarus', entityType: KD_COUNTRY },
        { value: '150.151.BG', label: 'Bulgaria', entityType: KD_COUNTRY },
        {
          value: '150.151.CZ',
          label: 'Czech Republic',
          entityType: KD_COUNTRY,
        },
        { value: '150.151.HU', label: 'Hungary', entityType: KD_COUNTRY },
        { value: '150.151.MD', label: 'Moldova', entityType: KD_COUNTRY },
        { value: '150.151.PL', label: 'Poland', entityType: KD_COUNTRY },
        { value: '150.151.RO', label: 'Romania', entityType: KD_COUNTRY },
        { value: '150.151.RU', label: 'Russia', entityType: KD_COUNTRY },
        { value: '150.151.SK', label: 'Slovakia', entityType: KD_COUNTRY },
        { value: '150.151.UA', label: 'Ukraine', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'AfricaWestern',
      label: 'Western Africa',
      data: [
        { value: '002.011.BJ', label: 'Benin', entityType: KD_COUNTRY },
        { value: '002.011.BF', label: 'Burkina Faso', entityType: KD_COUNTRY },
        { value: '002.011.CV', label: 'Cape Verde', entityType: KD_COUNTRY },
        { value: '002.011.CI', label: "Côte D'Ivoire", entityType: KD_COUNTRY },
        { value: '002.011.GM', label: 'Gambia', entityType: KD_COUNTRY },
        { value: '002.011.GH', label: 'Ghana', entityType: KD_COUNTRY },
        { value: '002.011.GN', label: 'Guinea', entityType: KD_COUNTRY },
        { value: '002.011.GW', label: 'Guinea-Bissau', entityType: KD_COUNTRY },
        { value: '002.011.LR', label: 'Liberia', entityType: KD_COUNTRY },
        { value: '002.011.ML', label: 'Mali', entityType: KD_COUNTRY },
        { value: '002.011.MR', label: 'Mauritania', entityType: KD_COUNTRY },
        { value: '002.011.NE', label: 'Niger', entityType: KD_COUNTRY },
        { value: '002.011.NG', label: 'Nigeria', entityType: KD_COUNTRY },
        {
          value: '002.011.SH',
          label: 'Saint Helena, Ascension and Tristan Da Cunha',
          entityType: KD_COUNTRY,
        },
        { value: '002.011.SN', label: 'Senegal', entityType: KD_COUNTRY },
        { value: '002.011.SL', label: 'Sierra Leone', entityType: KD_COUNTRY },
        { value: '002.011.TG', label: 'Togo', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'AfricaNorthern',
      label: 'Northern Africa',
      data: [
        { value: '002.015.DZ', label: 'Algeria', entityType: KD_COUNTRY },
        { value: '002.015.EG', label: 'Egypt', entityType: KD_COUNTRY },
        { value: '002.015.LY', label: 'Libya', entityType: KD_COUNTRY },
        { value: '002.015.MA', label: 'Morocco', entityType: KD_COUNTRY },
        { value: '002.015.SD', label: 'Sudan', entityType: KD_COUNTRY },
        { value: '002.015.TN', label: 'Tunisia', entityType: KD_COUNTRY },
        {
          value: '002.015.EH',
          label: 'Western Sahara',
          entityType: KD_COUNTRY,
        },
      ],
    },
    {
      value: 'AfricaMiddle',
      label: 'Middle Africa',
      data: [
        { value: '002.017.AO', label: 'Angola', entityType: KD_COUNTRY },
        { value: '002.017.CM', label: 'Cameroon', entityType: KD_COUNTRY },
        {
          value: '002.017.CF',
          label: 'Central African Republic',
          entityType: KD_COUNTRY,
        },
        { value: '002.017.TD', label: 'Chad', entityType: KD_COUNTRY },
        { value: '002.017.CG', label: 'Congo', entityType: KD_COUNTRY },
        {
          value: '002.017.CD',
          label: 'Democratic Republic of the Congo',
          entityType: KD_COUNTRY,
        },
        {
          value: '002.017.GQ',
          label: 'Equatorial Guinea',
          entityType: KD_COUNTRY,
        },
        { value: '002.017.GA', label: 'Gabon', entityType: KD_COUNTRY },
        {
          value: '002.017.ST',
          label: 'Sao Tome and Principe',
          entityType: KD_COUNTRY,
        },
      ],
    },
    {
      value: 'AfricaSouthern',
      label: 'Southern Africa',
      data: [
        { value: '002.018.BW', label: 'Botswana', entityType: KD_COUNTRY },
        { value: '002.018.LS', label: 'Lesotho', entityType: KD_COUNTRY },
        { value: '002.018.NA', label: 'Namibia', entityType: KD_COUNTRY },
        { value: '002.018.ZA', label: 'South Africa', entityType: KD_COUNTRY },
        { value: '002.018.SZ', label: 'Swaziland', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'AfricaEastern',
      label: 'Eastern Africa',
      data: [
        { value: '002.014.BI', label: 'Burundi', entityType: KD_COUNTRY },
        { value: '002.014.KM', label: 'Comoros', entityType: KD_COUNTRY },
        { value: '002.014.DJ', label: 'Djibouti', entityType: KD_COUNTRY },
        { value: '002.014.ER', label: 'Eritrea', entityType: KD_COUNTRY },
        { value: '002.014.ET', label: 'Ethiopia', entityType: KD_COUNTRY },
        { value: '002.014.KE', label: 'Kenya', entityType: KD_COUNTRY },
        { value: '002.014.MG', label: 'Madagascar', entityType: KD_COUNTRY },
        { value: '002.014.MW', label: 'Malawi', entityType: KD_COUNTRY },
        { value: '002.014.MU', label: 'Mauritius', entityType: KD_COUNTRY },
        { value: '002.014.YT', label: 'Mayotte', entityType: KD_COUNTRY },
        { value: '002.014.MZ', label: 'Mozambique', entityType: KD_COUNTRY },
        { value: '002.014.RW', label: 'Rwanda', entityType: KD_COUNTRY },
        { value: '002.014.RE', label: 'Réunion', entityType: KD_COUNTRY },
        { value: '002.014.SC', label: 'Seychelles', entityType: KD_COUNTRY },
        { value: '002.014.SO', label: 'Somalia', entityType: KD_COUNTRY },
        { value: '002.014.TZ', label: 'Tanzania', entityType: KD_COUNTRY },
        { value: '002.014.UG', label: 'Uganda', entityType: KD_COUNTRY },
        { value: '002.014.ZM', label: 'Zambia', entityType: KD_COUNTRY },
        { value: '002.014.ZW', label: 'Zimbabwe', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'AsiaWestern',
      label: 'Western Asia (Middle East)',
      data: [
        { value: '142.145.AM', label: 'Armenia', entityType: KD_COUNTRY },
        { value: '142.145.AZ', label: 'Azerbaijan', entityType: KD_COUNTRY },
        { value: '142.145.BH', label: 'Bahrain', entityType: KD_COUNTRY },
        { value: '142.145.CY', label: 'Cyprus', entityType: KD_COUNTRY },
        { value: '142.145.GE', label: 'Georgia', entityType: KD_COUNTRY },
        { value: '142.145.IQ', label: 'Iraq', entityType: KD_COUNTRY },
        { value: '142.145.IL', label: 'Israel', entityType: KD_COUNTRY },
        { value: '142.145.JO', label: 'Jordan', entityType: KD_COUNTRY },
        { value: '142.145.KW', label: 'Kuwait', entityType: KD_COUNTRY },
        { value: '142.145.LB', label: 'Lebanon', entityType: KD_COUNTRY },
        { value: '142.145.OM', label: 'Oman', entityType: KD_COUNTRY },
        { value: '142.145.PS', label: 'Palestine', entityType: KD_COUNTRY },
        { value: '142.145.QA', label: 'Qatar', entityType: KD_COUNTRY },
        { value: '142.145.SA', label: 'Saudi Arabia', entityType: KD_COUNTRY },
        { value: '142.145.SY', label: 'Syria', entityType: KD_COUNTRY },
        { value: '142.145.TR', label: 'Turkey', entityType: KD_COUNTRY },
        {
          value: '142.145.AE',
          label: 'United Arab Emirates',
          entityType: KD_COUNTRY,
        },
        { value: '142.145.YE', label: 'Yemen', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'AsiaCentral',
      label: 'Central Asia',
      data: [
        { value: '142.143.KZ', label: 'Kazakhstan', entityType: KD_COUNTRY },
        { value: '142.143.KG', label: 'Kyrgyzstan', entityType: KD_COUNTRY },
        { value: '142.143.TJ', label: 'Tajikistan', entityType: KD_COUNTRY },
        { value: '142.143.TM', label: 'Turkmenistan', entityType: KD_COUNTRY },
        { value: '142.143.UZ', label: 'Uzbekistan', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'AsiaSouthern',
      label: 'Southern Asia',
      data: [
        { value: '142.034.AF', label: 'Afghanistan', entityType: KD_COUNTRY },
        { value: '142.034.BD', label: 'Bangladesh', entityType: KD_COUNTRY },
        { value: '142.034.BT', label: 'Bhutan', entityType: KD_COUNTRY },
        { value: '142.034.IN', label: 'India', entityType: KD_COUNTRY },
        { value: '142.034.IR', label: 'Iran', entityType: KD_COUNTRY },
        { value: '142.034.MV', label: 'Maldives', entityType: KD_COUNTRY },
        { value: '142.034.NP', label: 'Nepal', entityType: KD_COUNTRY },
        { value: '142.034.PK', label: 'Pakistan', entityType: KD_COUNTRY },
        { value: '142.034.LK', label: 'Sri Lanka', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'AsiaSouthEastern',
      label: 'South-Eastern Asia',
      data: [
        {
          value: '142.035.BN',
          label: 'Brunei Darussalam',
          entityType: KD_COUNTRY,
        },
        { value: '142.035.KH', label: 'Cambodia', entityType: KD_COUNTRY },
        { value: '142.035.ID', label: 'Indonesia', entityType: KD_COUNTRY },
        { value: '142.035.LA', label: 'Laos', entityType: KD_COUNTRY },
        { value: '142.035.MY', label: 'Malaysia', entityType: KD_COUNTRY },
        { value: '142.035.MM', label: 'Myanmar', entityType: KD_COUNTRY },
        { value: '142.035.PH', label: 'Philippines', entityType: KD_COUNTRY },
        { value: '142.035.SG', label: 'Singapore', entityType: KD_COUNTRY },
        { value: '142.035.TH', label: 'Thailand', entityType: KD_COUNTRY },
        { value: '142.035.TL', label: 'Timor-Leste', entityType: KD_COUNTRY },
        { value: '142.035.VN', label: 'Viet Nam', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'AsiaEastern',
      label: 'Eastern Asia',
      data: [
        { value: '142.030.CN', label: 'China', entityType: KD_COUNTRY },
        { value: '142.030.HK', label: 'Hong Kong', entityType: KD_COUNTRY },
        { value: '142.030.JP', label: 'Japan', entityType: KD_COUNTRY },
        { value: '142.030.MO', label: 'Macao', entityType: KD_COUNTRY },
        { value: '142.030.MN', label: 'Mongolia', entityType: KD_COUNTRY },
        { value: '142.030.KP', label: 'North Korea', entityType: KD_COUNTRY },
        { value: '142.030.KR', label: 'South Korea', entityType: KD_COUNTRY },
        { value: '142.030.TW', label: 'Taiwan', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'OceaniaAustralia',
      label: 'Oceania Australia / NZ',
      data: [
        { value: '009.053.AU', label: 'Australia', entityType: KD_COUNTRY },
        { value: '009.053.NZ', label: 'New Zealand', entityType: KD_COUNTRY },
        {
          value: '009.053.NF',
          label: 'Norfolk Island',
          entityType: KD_COUNTRY,
        },
      ],
    },
    {
      value: 'OceaniaMelanesia',
      label: 'Oceania Melanesia',
      data: [
        { value: '009.054.FJ', label: 'Fiji', entityType: KD_COUNTRY },
        { value: '009.054.NC', label: 'New Caledonia', entityType: KD_COUNTRY },
        {
          value: '009.054.PG',
          label: 'Papua New Guinea',
          entityType: KD_COUNTRY,
        },
        {
          value: '009.054.SB',
          label: 'Solomon Islands',
          entityType: KD_COUNTRY,
        },
        { value: '009.054.VU', label: 'Vanuatu', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'OceaniaMicronesia',
      label: 'Oceania Micronesia',
      data: [
        { value: '009.057.GU', label: 'Guam', entityType: KD_COUNTRY },
        { value: '009.057.KI', label: 'Kiribati', entityType: KD_COUNTRY },
        {
          value: '009.057.MH',
          label: 'Marshall Islands',
          entityType: KD_COUNTRY,
        },
        { value: '009.057.FM', label: 'Micronesia', entityType: KD_COUNTRY },
        { value: '009.057.NR', label: 'Nauru', entityType: KD_COUNTRY },
        {
          value: '009.057.MP',
          label: 'Northern Mariana Islands',
          entityType: KD_COUNTRY,
        },
        { value: '009.057.PW', label: 'Palau', entityType: KD_COUNTRY },
      ],
    },
    {
      value: 'OceaniaPolynesia',
      label: 'Oceania Polynesia',
      data: [
        {
          value: '009.061.AS',
          label: 'American Samoa',
          entityType: KD_COUNTRY,
        },
        { value: '009.061.CK', label: 'Cook Islands', entityType: KD_COUNTRY },
        {
          value: '009.061.PF',
          label: 'French Polynesia',
          entityType: KD_COUNTRY,
        },
        { value: '009.061.NU', label: 'Niue', entityType: KD_COUNTRY },
        { value: '009.061.PN', label: 'Pitcairn', entityType: KD_COUNTRY },
        { value: '009.061.WS', label: 'Samoa', entityType: KD_COUNTRY },
        { value: '009.061.TK', label: 'Tokelau', entityType: KD_COUNTRY },
        { value: '009.061.TO', label: 'Tonga', entityType: KD_COUNTRY },
        { value: '009.061.TV', label: 'Tuvalu', entityType: KD_COUNTRY },
        {
          value: '009.061.WF',
          label: 'Wallis and Futuna',
          entityType: KD_COUNTRY,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./app/components/KdSelectGeography/checkboxOptions.js